import { useEffect, useMemo } from 'react'

import { selectCurrentUserStations, useAuthStore } from '@/lib/stores/auth'
import { selectSelectedStationCode, useStationStore } from '@/lib/stores/station'

export interface OperatingStationOption {
  name: string
  code: string
}

export const useOperatingStations = () => {
  const selectedStationCode = useStationStore(selectSelectedStationCode)
  const setSelectedStationCode = useStationStore((state) => state.setSelectedStationCode)
  const clearSelectedStationCode = useStationStore((state) => state.clearSelectedStationCode)

  const rawStations = useAuthStore(selectCurrentUserStations)

  const stations = useMemo(() => {
    const mappedStations = rawStations.map((station) => ({
      name: station.name,
      code: station.crs_code,
    }))
    const uniqueByCode = new Map(mappedStations.map((station) => [station.code, station]))
    return Array.from(uniqueByCode.values())
  }, [rawStations])

  useEffect(() => {
    if (stations.length === 0) {
      if (selectedStationCode) {
        clearSelectedStationCode()
      }
      return
    }

    const hasSelectedStation = stations.some((station) => station.code === selectedStationCode)

    if (!hasSelectedStation) {
      setSelectedStationCode(stations[0].code)
    }
  }, [clearSelectedStationCode, selectedStationCode, setSelectedStationCode, stations])

  return {
    stations,
    selectedStationCode,
    setSelectedStationCode,
  }
}
